import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
import SiloNav from './SiloNav';
import type { SiloId } from '../../types/blog';

interface BlogHeroProps {
  title?: string;
  subtitle?: string;
  activeSilo?: SiloId;
}

const BlogHero: React.FC<BlogHeroProps> = ({
  title = 'Blog dépannage informatique',
  subtitle = 'Guides pratiques, astuces et solutions pour tous vos problèmes informatiques — rédigés par nos techniciens.',
  activeSilo,
}) => {
  const revealUp = {
    hidden: { opacity: 0, y: 24 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <div className="relative py-20 min-h-[320px] overflow-hidden bg-surface">
      <div className="absolute inset-0">
        <img
          src="/images/heroes/blog-hero.webp"
          alt="Illustration du blog SOS IT Services"
          className="h-full w-full object-cover opacity-90"
          loading="eager"
        />
      </div>
      <div className="pointer-events-none absolute inset-0 bg-surface/40" />

      <div className="relative z-10 container-site text-center">
        <motion.div
          variants={revealUp}
          initial="hidden"
          animate="show"
          transition={{ duration: 0.55, ease: 'easeOut' }}
        >
          <motion.span
            className="inline-flex items-center gap-2 rounded-full border border-accent/40 bg-accent-strong/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-accent-soft mb-5"
            animate={{
              boxShadow: [
                '0 0 0 rgba(88,101,242,0)',
                '0 0 24px rgba(88,101,242,0.25)',
                '0 0 0 rgba(88,101,242,0)',
              ],
            }}
            transition={{ duration: 2.8, repeat: Infinity, ease: 'easeInOut' }}
          >
            <BookOpen className="h-3.5 w-3.5" />
            Guides & conseils
          </motion.span>

          <h1 className="heading-display mb-5">
            {title.includes('Dépannage') ? (
              <>
                Blog{' '}
                <span className="text-accent-soft">Dépannage Informatique</span>
              </>
            ) : (
              title
            )}
          </h1>

          <p className="section-intro">{subtitle}</p>
        </motion.div>

        <motion.div
          className="mt-8"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45, delay: 0.08, ease: 'easeOut' }}
        >
          <SiloNav activeSilo={activeSilo} />
        </motion.div>
      </div>
    </div>
  );
};

export default BlogHero;
